var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChartTypePie(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7498 11.2493V2.58008C15.0947 2.76608 17.0751 3.67124 18.6911 5.29558C20.3071 6.91991 21.2164 8.9045 21.4191 11.2493H12.7498ZM11.2653 21.3936C8.81533 21.2076 6.757 20.2146 5.09033 18.4146C3.42367 16.6146 2.59033 14.4762 2.59033 11.9993C2.59033 9.50583 3.42367 7.35908 5.09033 5.55908C6.757 3.75908 8.81533 2.76608 11.2653 2.58008V21.3936ZM12.7498 21.3936V12.7338H21.4191C21.2369 15.0723 20.3328 17.0563 18.7066 18.6858C17.0802 20.3153 15.0947 21.2179 12.7498 21.3936Z",
    fill: "#304674"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartTypePie);
export default __webpack_public_path__ + "static/media/chart-type-PIE.df4d85bd922aa1691d2e541b15d066a4.svg";
export { ForwardRef as ReactComponent };